(ns bp-clients.tv-app.nav.views.network
  (:require
   [bp-clients.tv-app.common.events :as common-events]
   [bp-libs.design-system.components.modal :refer [Modal]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn network-modal
  "Informs the user whenever the connection is dropped and is
  reestablished. A requirement for both Samsung [1] and LG app stores

  [1]: https://developer.samsung.com/smarttv/develop/development-checklist.html"
  [{:keys [react-ref]}]
  (let [trying-to-reconnect? (r/atom false)]
    (fn [] [Modal
            (merge {:header  "Erro de conexão"
                    :message "Seu aparelho pode não estar conectado à Internet. Por favor, confirme que sua internet está funcionando."}
                   (if @trying-to-reconnect?
                     {:spinner? true}
                     {:button {:react-ref react-ref
                               :title     "Voltar"
                               :on-click  #(do (js/setTimeout (fn []
                                                                (reset! trying-to-reconnect? false))
                                                              5000)
                                               (reset! trying-to-reconnect? true)
                                               (rf/dispatch [::common-events/process-error-queue]))}}))])))

